import React, { useRef, useEffect, FC } from "react";
import gsap from "gsap";
import { SplitText } from "gsap/dist/SplitText";
import { CustomEase } from "gsap/dist/CustomEase";

gsap.registerPlugin(CustomEase, SplitText);

interface Props {
  htmlElement: JSX.Element;
  isInView: boolean;
  className?: string;
}

const SplitTextAnimation: FC<Props> = ({
  htmlElement,
  isInView,
  className,
}) => {
  const ref = useRef(null);
  const splitTextTimelineRef = useRef<any>(null);

  useEffect(() => {
    const container = ref.current as HTMLElement | null;

    if (!container) return;

    splitTextTimelineRef.current = gsap.timeline({
      paused: true,
    });

    const elementToAnimate = container.querySelector("h1, h2");

    if (!elementToAnimate) return;

    new SplitText(elementToAnimate, {
      type: "lines",
      linesClass: "line",
      position: "relative",
    });

    CustomEase.create(
      "customEase",
      "M0,0 C0.2,0 0.337,0.566 0.47,0.772 0.615,0.998 0.822,1 1,1"
    );

    const lineElements = elementToAnimate.querySelectorAll(".line");

    lineElements.forEach((lineElement) => {
      lineElement.innerHTML = `<div class="line-inner">${lineElement.textContent}</div>`;
    });

    const headingInner = elementToAnimate.querySelectorAll(".line-inner");

    splitTextTimelineRef.current.staggerTo(
      headingInner,
      0.7,
      { y: 0, force3D: true, ease: "customEase" },
      0.1
    );

    if (isInView) {
      splitTextTimelineRef.current.play();
    }
  }, [isInView]);

  useEffect(() => {
    // Pause the animation when the title is out of view
    if (!isInView && splitTextTimelineRef.current) {
      splitTextTimelineRef.current.pause();
    }
  }, [isInView]);

  return (
    <div ref={ref} className={`${className || ""}`}>
      {htmlElement}
    </div>
  );
};

export default SplitTextAnimation;
